var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDormsInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.2,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tree-city-solid",
    d: "M10.8,1.8A1.8,1.8,0,0,1,12.6,0h3.6A1.8,1.8,0,0,1,18,1.8V7.2h1.5V4.5a.9.9,0,0,1,1.8,0V7.2h.9A1.8,1.8,0,0,1,24,9v8.4a1.8,1.8,0,0,1-1.8,1.8H12.6a1.8,1.8,0,0,1-1.8-1.8ZM13.2,3V4.2a.6.6,0,0,0,.6.6H15a.6.6,0,0,0,.6-.6V3a.6.6,0,0,0-.6-.6H13.8A.6.6,0,0,0,13.2,3Zm.6,3a.6.6,0,0,0-.6.6V7.8a.6.6,0,0,0,.6.6H15a.6.6,0,0,0,.6-.6V6.6A.6.6,0,0,0,15,6Zm-.6,4.2v1.2a.6.6,0,0,0,.6.6H15a.6.6,0,0,0,.6-.6V10.2a.6.6,0,0,0-.6-.6H13.8A.6.6,0,0,0,13.2,10.2Zm6.6-.6a.6.6,0,0,0-.6.6v1.2a.6.6,0,0,0,.6.6H21a.6.6,0,0,0,.6-.6V10.2a.6.6,0,0,0-.6-.6Zm-.6,4.2V15a.6.6,0,0,0,.6.6H21a.6.6,0,0,0,.6-.6V13.8a.6.6,0,0,0-.6-.6H19.8A.6.6,0,0,0,19.2,13.8ZM8.4,6a2.915,2.915,0,0,1-.075.6A2.964,2.964,0,0,1,6.6,12H6v6a1.208,1.208,0,0,1-1.2,1.2A1.185,1.185,0,0,1,3.6,18V12H3A2.982,2.982,0,0,1,1.238,6.6,3.031,3.031,0,0,1,1.2,6,3.6,3.6,0,0,1,8.4,6Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDormsInfoIcon);
export default __webpack_public_path__ + "static/media/dorms-info-icon.dcb7a78b551ce3a955d5003476c2d91e.svg";
export { ForwardRef as ReactComponent };